import axios from 'axios';
import { IpcCall, ipcCall } from '../lite/utils/ipcCall';

/**
 * @abstract
 */
export class AccountService {

    static instance;

    static getInstance() {
        if (AccountService.instance) {
            return AccountService.instance;
        }

        if (window.ipcRenderer) {
            return AccountService.instance = new IpcAccountService();
        }

        return AccountService.instance = new HttpAccountService();
    }

    async getConfirmationToken(data) {
        throw new Error('Not implemented');
    }

    async updateAccount(data) {
        throw new Error('Not implemented');
    }

    async updatePassword(data, confirmationToken) {
        throw new Error('Not implemented');
    }

    async deleteAccount(confirmationToken) {
        throw new Error('Not implemented');
    }
}

class IpcAccountService extends AccountService {
    async getConfirmationToken(data) {
        return ipcCall(IpcCall.GetConfirmationToken, data);
    }

    async updateAccount(data) {
        return ipcCall(IpcCall.UpdateAccount, data);
    }

    async updatePassword(data, confirmationToken) {
        return ipcCall(IpcCall.UpdatePassword, {
            ...data,
            confirmation: confirmationToken,
        });
    }

    async deleteAccount(confirmationToken) {
        return await ipcCall(IpcCall.DeleteAccount, {
            confirmation: confirmationToken,
        });
    }

    async sendPasswordResetLink(email) {
        return ipcCall(IpcCall.ForgotPassword, {
            email,
        });
    }
}

class HttpAccountService extends AccountService {
    async getConfirmationToken(data) {
        return (await axios.post('/api/user/confirmation', data)).data.confirmation;
    }

    async updateAccount(data) {
        return axios.post('/api/user', data);
    }

    async updatePassword(data, confirmationToken) {
        return axios.post('/api/user/password', {
            ...data,
            confirmation: confirmationToken,
        });
    }

    async deleteAccount(confirmationToken) {
        return axios.post('/api/user', {
            _method: 'DELETE',
            confirmation: confirmationToken,
        });
    }

    async sendPasswordResetLink(email) {
        return axios.post('/api/password/email', {
            email,
        });
    }
}
